import type { ReactNode } from 'react';

interface ArchHeaderProps {
  /** Content centered in the circular mark at the top of the arch (a letter or icon). */
  mark: ReactNode;
}

/**
 * The "Badeel Islamic Theme" signature header (docs/decisions.md DD-003): a
 * primary-gradient arch topped with an 8-point geometric star motif and a
 * circular mark. Used on the sign-in and profile screens, mirroring the
 * imported design (claude.ai/design project c2117558-733f-42d0-89af-c47f40e7bb61).
 */
export function ArchHeader({ mark }: ArchHeaderProps): JSX.Element {
  return (
    <div className="arch-header">
      <svg
        className="arch-header__motif"
        viewBox="0 0 200 60"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        <defs>
          <pattern id="badeel-star8" width="20" height="20" patternUnits="userSpaceOnUse">
            <path
              d="M10 0 L13 7 L20 10 L13 13 L10 20 L7 13 L0 10 L7 7 Z"
              fill="none"
              stroke="var(--color-primary-contrast)"
              strokeWidth="0.6"
            />
          </pattern>
        </defs>
        <rect width="200" height="60" fill="url(#badeel-star8)" />
      </svg>
      <div className="arch-header__dome" />
      <div className="arch-header__mark">{mark}</div>
    </div>
  );
}
